import { useContext, useState } from "react";
import { Button, Table } from "react-bootstrap";
import { Trash } from "react-feather";
import { DeleteModal } from "../../../../components/DeleteModal";
import NotyfContext from "../../../../contexts/NotyfContext.jsx";
import api from "../../../../service/api";
import { formatNumberWithCommas } from "../../../../utils/utility";
import { useSelector } from "react-redux";

export default function BankPayments({ payments = [], onDelete = null }) {
    const notyf = useContext(NotyfContext);
    const permissions = useSelector((state) => state.user?.data?.permissions);

    const [modalInfo, setModalInfo] = useState({
        id: null,
        notifMsg: "Are you sure you want to delete this payment?",
        open: false,
        severity: "danger",
    });

    const openDeleteModal = (payment) => {
        setModalInfo({
            id: payment?.id ?? null,
            notifMsg: "Are you sure you want to delete this payment?",
            open: true,
            severity: "danger",
        });
    };

    const deletePayment = async (paymentId) => {
        if (!paymentId) {
            notyf?.error("Payment id is missing.");
            return;
        }

        try {
            await api.delete(`tms/bank-transaction/payment/${paymentId}`);
            notyf?.success("Payment deleted successfully.");

            if (typeof onDelete === "function") {
                await onDelete();
            }
        } catch (error) {
            const message =
                error?.response?.data?.message ||
                error?.message ||
                "Error deleting payment";
            notyf?.error(message);
        }
    };

    return (
        <>
            <Table striped bordered hover responsive>
                <thead className="table">
                    <tr
                        style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                        }}
                    >
                        <th>S.No</th>
                        <th>Company Name</th>
                        <th>Invoice Number</th>
                        <th>Amount Paid</th>
                        <th>Created At</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                    {payments.length === 0 ? (
                        <tr>
                            <td colSpan={6} className="text-center">
                                No data available
                            </td>
                        </tr>
                    ) : (
                        payments.map((data, index) => (
                            <tr key={data.id ?? index}>
                                <td>{index + 1}</td>
                                <td>{data?.company?.name || "-"}</td>
                                <td>
                                    {data.payment?.invoice_id ? (
                                        <a
                                            href={`/tms/invoices/payments/${data?.payment?.invoice_id}`}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            {data.invoice_number}
                                        </a>
                                    ) : (
                                        data.invoice_number || "-"
                                    )}
                                </td>
                                <td>
                                    ${formatNumberWithCommas(data.amount_paid ?? 0)}
                                </td>
                                <td>{data.created_at || "-"}</td>
                                <td>
                                    {permissions.includes("BANK-TRANSACTION-DELETE") &&
                                    data?.type == 'manual'
                                    && (
                                        <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => openDeleteModal(data)}
                                            title="Delete payment"
                                        >
                                            <Trash size={14} />
                                        </Button>
                                    )}
                                </td>
                            </tr>
                        ))
                    )}
                </tbody>
            </Table>

            <DeleteModal
                modalInfo={modalInfo}
                setModalInfo={setModalInfo}
                api={deletePayment}
            />
        </>
    );
}
